import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import '../appDatenschutz/AppDatenschutz.css';
import { Header } from '../../components/header/Header';
import { MobileFooter } from '../../components/mobileFooter/MobileFooter';

export const AgbsPage = () => {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, margin: '-100px' });

	return (
		<div>
			<Header style={{ backgroundColor: '#ffffff' }} />
			<div className='app-datenschutz-page'>
				<motion.div
					ref={ref}
					initial={{ opacity: 0, y: 20 }}
					animate={isInView ? { opacity: 1, y: 0 } : {}}
					transition={{ duration: 0.5, ease: 'easeOut' }}
					className='datenschutz-container'
				>
					<h1>Allgemeine Geschäftsbedingungen (AGB)</h1>
					<p className='stand'>für die App „Erledix“ | Stand: Februar 2026</p>

					<div className='datenschutz-content'>
						<section>
							<h2>1. Geltungsbereich</h2>
							<p>1.1 Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Nutzung der App „Erledix“ durch Verbraucher im Sinne von § 13 BGB.</p>
							<p>1.2 Die App richtet sich ausschließlich an Eltern bzw. Erziehungsberechtigte, die organisatorische Aufgaben innerhalb des Familienalltags verwalten und altersgerecht mit ihren Kindern teilen möchten.</p>
							<p>1.3 Abweichende, entgegenstehende oder ergänzende Bedingungen der Nutzer finden keine Anwendung, sofern ihrer Geltung nicht ausdrücklich schriftlich durch den Anbieter zugestimmt wurde.</p>
						</section>

						<section>
							<h2>2. Anbieter</h2>
							<p>Anbieter der App ist:</p>
							<p>
								Health365 IT GmbH
								<br />
								Unter den Linden 10
								<br />
								10117 Berlin
								<br />
								E-Mail: kontakt@erledix.de
							</p>
						</section>

						<section>
							<h2>3. Leistungsbeschreibung</h2>
							<p>3.1 Die App ermöglicht Eltern insbesondere:</p>
							<ul>
								<li>das Erstellen und Verwalten von Aufgaben für Kinder,</li>
								<li>das Teilen von Aufgaben innerhalb eines Familienkontos,</li>
								<li>das Nachverfolgen von Erledigungsstatus und Fortschritten,</li>
								<li>die Nutzung spielerischer Elemente wie Punkte oder virtuelle Münzen,</li>
								<li>optionale Erinnerungen und Benachrichtigungen.</li>
							</ul>
							<p>3.2 Die App dient ausschließlich der Organisation und spielerischen Unterstützung des Familienalltags. Sie stellt keine pädagogische, psychologische, therapeutische oder sonstige fachliche Beratung dar.</p>
							<p>3.3 Es wird kein bestimmter organisatorischer, erzieherischer oder sonstiger Erfolg durch die Nutzung der App geschuldet oder zugesichert.</p>
							<p>3.4 Der Anbieter behält sich vor, Funktionen, Inhalte oder den Umfang der App jederzeit zu ändern, zu erweitern oder einzustellen. Ein Anspruch auf bestimmte Funktionen oder eine permanente Verfügbarkeit besteht nicht.</p>
						</section>

						<section>
							<h2>4. Virtuelle Münzen und Belohnungen</h2>
							<p>4.1 Innerhalb der App verwendete Münzen, Punkte oder vergleichbare virtuelle Einheiten dienen ausschließlich spielerischen Zwecken.</p>
							<p>4.2 Diese virtuellen Einheiten haben keinen realen Geldwert, sind nicht auszahlbar, nicht übertragbar und begründen keinen rechtlichen Anspruch gegenüber dem Anbieter.</p>
							<p>4.3 Art, Umfang und Einlösung möglicher Belohnungen werden ausschließlich von den Eltern bzw. Erziehungsberechtigten festgelegt und außerhalb der App gewährt.</p>
						</section>

						<section>
							<h2>5. Beta-Version</h2>
							<p>5.1 Die App befindet sich – auch bei öffentlicher Verfügbarkeit in App Stores – weiterhin im Beta-Status.</p>
							<p>5.2 Während der Beta-Phase kann es insbesondere zu:</p>
							<ul>
								<li>funktionalen Einschränkungen,</li>
								<li>Fehlern oder Fehlfunktionen,</li>
								<li>Datenverlusten,</li>
								<li>vorübergehender Nichtverfügbarkeit</li>
							</ul>
							<p>kommen.</p>
							<p>5.3 Die Nutzung der Beta-Version erfolgt auf eigenes Risiko.</p>
							<p>5.4 Nutzer sind selbst dafür verantwortlich, relevante Daten regelmäßig zu sichern. Der Anbieter übernimmt keine Gewähr für die dauerhafte Speicherung oder Wiederherstellung von Daten.</p>
						</section>

						<section>
							<h2>6. Registrierung und Nutzerkonten</h2>
							<p>6.1 Die Nutzung der App setzt die Erstellung eines Elternkontos voraus.</p>
							<p>6.2 Kinderkonten können ausschließlich durch Eltern bzw. Erziehungsberechtigte innerhalb eines Elternkontos erstellt und verwaltet werden.</p>
							<p>6.3 Kinder werden nicht Vertragspartner des Anbieters.</p>
							<p>6.4 Nutzer sind verpflichtet, ihre Zugangsdaten vertraulich zu behandeln und vor dem Zugriff Dritter zu schützen.</p>
							<p>6.5 Bei Verdacht auf Missbrauch der Zugangsdaten ist der Anbieter unverzüglich zu informieren.</p>
						</section>

						<section>
							<h2>7. Nutzung durch Kinder und elterliche Verantwortung</h2>
							<p>7.1 Eltern bzw. Erziehungsberechtigte tragen die alleinige Verantwortung für:</p>
							<ul>
								<li>die Einrichtung und Verwaltung von Kinderkonten,</li>
								<li>die innerhalb der App erstellten Aufgaben, Inhalte und Anweisungen,</li>
								<li>die Art, Häufigkeit und Intensität der Nutzung der App durch Kinder,</li>
								<li>die Ausgestaltung von Regeln, Motivation und Belohnungen.</li>
							</ul>
							<p>7.2 Der Anbieter übernimmt keine Verantwortung für Auswirkungen der App-Nutzung auf Verhalten, Motivation, Leistung oder Wohlbefinden von Kindern.</p>
						</section>

						<section>
							<h2>8. Pflichten der Nutzer</h2>
							<p>8.1 Nutzer verpflichten sich, die App nicht missbräuchlich zu nutzen und insbesondere:</p>
							<ul>
								<li>keine rechtswidrigen Inhalte einzustellen,</li>
								<li>keine Inhalte zu verwenden, die Kinder gefährden, verletzen oder manipulieren,</li>
								<li>keine automatisierten Zugriffe oder Manipulationen vorzunehmen.</li>
							</ul>
							<p>8.2 Die App darf nicht verwendet werden für:</p>
							<ul>
								<li>Überwachungszwecke außerhalb des vorgesehenen Funktionsumfangs,</li>
								<li>kommerzielle Zwecke ohne ausdrückliche Zustimmung des Anbieters.</li>
							</ul>
						</section>

						<section>
							<h2>9. Inhalte und Verantwortung</h2>
							<p>9.1 Alle innerhalb der App erstellten Inhalte (z. B. Aufgaben, Texte, Namen) stammen vom Nutzer und liegen in dessen Verantwortung.</p>
							<p>9.2 Der Anbieter übernimmt keine Haftung für Inhalte, die Nutzer innerhalb der App erstellen, speichern oder teilen.</p>
						</section>

						<section>
							<h2>10. Verfügbarkeit</h2>
							<p>10.1 Der Anbieter bemüht sich um eine möglichst hohe Verfügbarkeit der App, übernimmt jedoch keine Garantie für eine unterbrechungsfreie Nutzung.</p>
							<p>10.2 Wartungsarbeiten, Sicherheitsupdates oder technische Störungen können zu vorübergehenden Einschränkungen führen.</p>
						</section>

						<section>
							<h2>11. Kommunikation, Feedback und Umfragen</h2>
							<p>11.1 Der Anbieter ist berechtigt, Nutzer per E-Mail oder innerhalb der App zu kontaktieren, um Feedback, Erfahrungsberichte, Umfragen oder produktbezogene Hinweise zur Weiterentwicklung der App einzuholen.</p>
							<p>11.2 Nutzer können dieser Kontaktaufnahme jederzeit widersprechen.</p>
						</section>

						<section>
							<h2>12. Haftung</h2>
							<p>12.1 Der Anbieter haftet unbeschränkt:</p>
							<ul>
								<li>bei Vorsatz oder grober Fahrlässigkeit,</li>
								<li>bei Verletzung von Leben, Körper oder Gesundheit.</li>
							</ul>
							<p>12.2 Bei leichter Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) und beschränkt auf den vorhersehbaren, vertragstypischen Schaden.</p>
							<p>12.3 Eine Haftung für Datenverluste ist ausgeschlossen, sofern diese durch regelmäßige und zumutbare Datensicherungen seitens des Nutzers vermeidbar gewesen wären.</p>
						</section>

						<section>
							<h2>13. Datenschutz</h2>
							<p>13.1 Die Verarbeitung personenbezogener Daten erfolgt gemäß der Datenschutzerklärung der App.</p>
							<p>13.2 Die Datenschutzerklärung ist jederzeit innerhalb der App oder auf der Website einsehbar.</p>
						</section>

						<section>
							<h2>14. Vertragslaufzeit und Kündigung</h2>
							<p>14.1 Der Nutzungsvertrag läuft auf unbestimmte Zeit.</p>
							<p>14.2 Nutzer können ihr Konto jederzeit ohne Angabe von Gründen löschen.</p>
							<p>14.3 Der Anbieter behält sich vor, Nutzerkonten bei schweren oder wiederholten Verstößen gegen diese AGB zu sperren oder zu löschen.</p>
						</section>

						<section>
							<h2>15. Änderungen der AGB</h2>
							<p>15.1 Der Anbieter behält sich vor, diese AGB zu ändern.</p>
							<p>15.2 Änderungen werden den Nutzern rechtzeitig in geeigneter Form (z. B. innerhalb der App) mitgeteilt.</p>
							<p>15.3 Widerspricht der Nutzer nicht innerhalb von 14 Tagen nach Mitteilung, gelten die Änderungen als akzeptiert.</p>
						</section>

						<section>
							<h2>16. Anwendbares Recht</h2>
							<p>16.1 Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.</p>
							<p>16.2 Für Verbraucher gilt dies nur, soweit dadurch keine zwingenden gesetzlichen Vorschriften des Wohnsitzlandes eingeschränkt werden.</p>
						</section>

						<section className='contact-section'>
							<h2>17. Salvatorische Klausel</h2>
							<p>Sollte eine Bestimmung dieser AGB ganz oder teilweise unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
						</section>
					</div>
				</motion.div>
			</div>
			<MobileFooter />
		</div>
	);
};